import React, { useEffect } from 'react';
import moment from 'moment';
import {
  Filters,
  FiltersLayout,
  List,
  MonthFilter,
  RelationListLayout,
  useListLocalStorageStoring,
} from 'framework/list';
import usePerformanceReportService, {
  DIVIDER,
  METRICS,
} from 'domain/people/employee/performanceReport/usePerformanceReportService';
import PerformanceHeatmap from 'domain/people/employee/performanceReport/shared/PerformanceHeatmap/index';
import { useLocation } from 'react-router-dom';
import { DATE_FORMAT } from 'framework/utils';

const PerformanceReportsListPage = () => {
  const { search } = usePerformanceReportService();
  const location = useLocation();
  const localStorageKey = location.pathname;
  const { updateParamsInLocalStorage } = useListLocalStorageStoring({ localStorageKey });
  const currentMonth = moment().format(DATE_FORMAT.API_ONLY_MONTH);

  useEffect(() => {
    return () => {
      updateParamsInLocalStorage({
        filter: {},
      });
    };
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filter = (
    <Filters>
      <FiltersLayout>
        <MonthFilter label="" source="period" isRequired sx={{ mb: '0 !important' }} />
      </FiltersLayout>
    </Filters>
  );

  return (
    <List
      localStorageKey={localStorageKey}
      getDataMethod={search}
      defaultFilter={{
        period: {
          eq: currentMonth,
        },
      }}
    >
      <RelationListLayout header="Performance report" headerVariant="h4">
        <PerformanceHeatmap
          labels={[
            METRICS.TIMELY_CHECKIN,
            METRICS.SAME_DAY_TIME_REPORT,
            METRICS.LOCATION_TIMEZONE,
            DIVIDER,
            METRICS.MICRO_AVAILABILITY,
            METRICS.EFFECTIVE_CAPACITY,
            DIVIDER,
            METRICS.TICKETS_PLANNED,
            METRICS.RESOLVED_TICKETS,
            METRICS.ASSIGNED_TICKETS,
            METRICS.OVERDUE_PROCESSES_TICKETS,
            METRICS.BLOCKED_TICKETS,
            METRICS.REASSIGNED_TICKETS,
            METRICS.REJECTED_TICKETS,
          ]}
          filter={filter}
        />
      </RelationListLayout>
    </List>
  );
};

export default PerformanceReportsListPage;
